// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial;
}

.aJjQCvFfADvOPUqw8Lgw {
  padding: 8px;
  width: 320px;
  background-color: grey;
  color: white;
}

.pe9Q_BauDKw4bmib3bAZ {
  display: flex;
  flex-wrap: wrap;
}

.CfN8R96YjpycqIkbNQru {
  background: url(/assets/bees.png);
  display: inline-block;
  margin: 4px;
  height: 32px;
  width: 32px;
  background-size: 320px;
}

.eFxQmlJxik3W7Q9EATtQ {
  border-bottom: 1px solid white;
  margin: 4px 0px;
}

.G8d_ptvyLlDpcOzs0TvR {
  position: relative;
}
.G8d_ptvyLlDpcOzs0TvR .CUtbtkKAWn3uu1m3YYPF {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}
.G8d_ptvyLlDpcOzs0TvR .iM71YHgYKkWIcPWCGRXO {
  margin-left: 8px;
  font-weight: bold;
}
.G8d_ptvyLlDpcOzs0TvR .RL1044gmFGx_BU6qaqNa {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}

.UG5AgL07y8ZBs04mbeE4 {
  display: inline-block;
  background: white;
  color: black;
  border: 3px solid black;
  padding: 0 8px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/ui/SideBar.sass"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;;AACA;EACC,YAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;AAED;;AAAA;EACC,aAAA;EACA,eAAA;AAGD;;AADA;EACC,iCAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AAID;;AAFA;EACC,8BAAA;EACA,eAAA;AAKD;;AAHA;EACC,kBAAA;AAMD;AALC;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAOF;AANC;EACC,gBAAA;EACA,iBAAA;AAQF;AAPC;EACC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;AASF;;AAPA;EACC,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AAUD","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideBar": `aJjQCvFfADvOPUqw8Lgw`,
	"swarm": `pe9Q_BauDKw4bmib3bAZ`,
	"bee": `CfN8R96YjpycqIkbNQru`,
	"separator": `eFxQmlJxik3W7Q9EATtQ`,
	"ability": `G8d_ptvyLlDpcOzs0TvR`,
	"header": `CUtbtkKAWn3uu1m3YYPF`,
	"text": `iM71YHgYKkWIcPWCGRXO`,
	"cooldown": `RL1044gmFGx_BU6qaqNa`,
	"key": `UG5AgL07y8ZBs04mbeE4`
};
export default ___CSS_LOADER_EXPORT___;
